<template>
    <div class="home-main">
        <!-- navbar -->
        <HomeNavbar></HomeNavbar>
        <!-- action buttons -->
        <Actions :displayMode="displayMode" :allData="allData" @refresh="refresh" @on-selectedws_id-change="onWsidChange" @on-search-machine="onSearchMachine" @on-change-display="onChangeDisplay"></Actions>
        <!-- list -->
        <Spin class="loading" size="large" fix v-if="spinShow"></Spin>
        <Row :gutter="15" v-if="displayMode==0">
            <Col span="4" v-for="item in groups" :key="item.dev_id" style="padding-bottom:15px;">
                <Card :padding="0" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);">
                    <Item :item="item"></Item>
                </Card>
            </Col>
        </Row>
        <Row :gutter="15" v-else>
            <Col span="24" v-for="item in groups" :key="item.dev_id" style="padding-bottom:15px;">
                <Card :padding="0" :bordered="false" shadow style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);">
                    <ItemList :item="item"></ItemList>
                </Card>
            </Col>
        </Row>
        <HomeFooter/>
    </div>
</template>

<script>
import HomeNavbar from './components/navbar.vue';
import Actions from './components/actions.vue';
import Item from './components/item.vue';
import ItemList from './components/itemList.vue';
import HomeFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';

export default {
    name: 'home',
    components: {
        HomeNavbar,
        Actions,
        Item,
        ItemList,
        HomeFooter
    },
    data() {
        return {
            Cancel: null, //添加取消请求函数
            cid: this.$store.state.user.cid,
            allData: {},
            spinShow: true,
            groups: [],
            displayMode: this.$store.state.displayMode, //0卡片 1列表
            selectedws_id: this.$store.state.homeSelectShop, // 当前选中的工厂标签
            groupName: '' //机组名称
        };
    },
    created() {
        this.$store.commit('upNavbar', 0);
    },
    mounted() {
        this.getGroups();
        let groupsIntval = setInterval(() => {
            this.getGroups();
        }, 60000); // 定时刷新机组
        this.$once('hook:beforeDestroy', () => {
            clearInterval(groupsIntval);
        });
    },
    beforeDestroy() {},
    methods: {
        // 获取机组信息
        getGroups() {
            if (this.Cancel != null) this.Cancel(); //进来先删除上一次请求
            let CancelToken = Axios.CancelToken;
            var ws_id = this.selectedws_id ? this.selectedws_id : '';
            Axios.get(AxiosUrl.group.listbyws, {
                params: {
                    cid: this.cid,
                    ws_id,
                    name: this.groupName
                },
                cancelToken: new CancelToken(c => {
                    this.Cancel = c;
                })
            })
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data;
                        this.allData = {
                            finish: 0,
                            total: 0,
                            run: 0,
                            stby: 0,
                            alarm: 0,
                            off: 0,
                            power: 0,
                            stop: 0
                        };
                        data.forEach(el => {
                            this.allData.finish += el.finish;
                            this.allData.total += el.total;
                            this.allData.run += el.run;
                            this.allData.stby += el.stby;
                            this.allData.alarm += el.alarm;
                            this.allData.off += el.off;
                            this.allData.power += el.power;
                            this.allData.stop += el.stop;
                        });
                        this.groups = data;
                        this.spinShow = false;
                    } else {
                        console.log(res.data.msg);
                        this.spinShow = false;
                    }
                })
                .catch(err => {});
        },
        // 刷新组信息
        refresh() {
            // this.selectedws_id = 0;
            this.groupName = '';
            this.spinShow = true;
            this.getGroups();
        },
        onWsidChange(selectedws_id, name) {
            this.selectedws_id = selectedws_id;
            this.$store.commit('setHomeSelectShop', selectedws_id);
            this.groupName = name;
            this.spinShow = true;
            this.getGroups();
        },
        //机组名称查询
        onSearchMachine(name) {
            this.groupName = name;
            this.spinShow = true;
            this.getGroups();
        },
        //修改显示方式
        onChangeDisplay(mode) {
            this.displayMode = mode;
        }
    }
};
</script>
<style lang="less">
.home-main {
    .loading {
        background-color: #d7d7d7;
    }
}
</style>





// WEBPACK FOOTER //
// src/views/home/home.vue